import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { IWidget, IWidgetFactory } from '../../widgets';

class SeriesSelectionPanelController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    item: IWidget;
    
    //TODO add all bindings

    static $inject = ['widgetFactory'];
    constructor(private widgetFactory: IWidgetFactory) {
    }

    $onInit() {
        if (!this.item) {
            this.item = this.widgetFactory.createWidget('seriesSelection');
        }
    }
}

export const wtSeriesSelectionPanel: ComponentDefinition = {
    componentId: 'wtSeriesSelectionPanel',
    controller: SeriesSelectionPanelController,
    template: require('./seriesSelectionPanel.component.html'),
    controllerAs: 'vm',
    bindings: {
        disablePlus: '<?',
        excludeTags: '<?',
        extraSelectorViewModels: '=?',
        extraViewModels: '=?',
        hasConnectionPoints: '<?',
        includeQueries: '<?',
        isBindable: '=?',
        item: '=?',
    }
};
